import { Gift, Share2, Copy } from "lucide-react";
import { toast } from "sonner";

/** Referral card: share link that earns the member a free month when a friend joins. */
export function ReferralCard({ m }) {
  if (!m.referral_url) return null;
  const text = `I use Dr.Gadget Care for tech help — priority answers and 10% off sessions. Join with my link: ${m.referral_url}`;

  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: "Join Dr.Gadget Care", text, url: m.referral_url }); return; } catch { return; }
    }
    try { await navigator.clipboard.writeText(text); toast.success("Referral link copied"); } catch { toast.error("Couldn't copy — long-press the link instead"); }
  };
  const copy = async () => {
    try { await navigator.clipboard.writeText(m.referral_url); toast.success("Link copied"); } catch { toast.error("Couldn't copy"); }
  };

  return (
    <div className="mt-6 rounded-xl border border-slate-800 bg-slate-900/50 p-4 text-sm" data-testid="membership-referral">
      <div className="flex items-start gap-3">
        <Gift className="w-5 h-5 text-[#FFD600] shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <div className="font-display font-semibold">Give a friend Dr.Gadget Care — get a free month.</div>
          <p className="text-slate-400 mt-1">When someone joins with your link and their first payment goes through, Stripe skips your next charge and your perks stay on.</p>
          <div className="mt-3 flex flex-col sm:flex-row gap-2">
            <code className="flex-1 truncate rounded-lg bg-slate-950 border border-slate-800 px-3 py-2 text-xs text-cyan-300" data-testid="membership-referral-link">{m.referral_url}</code>
            <div className="flex gap-2">
              <button type="button" onClick={copy} className="dg-btn-ghost rounded-full px-3 py-2 text-xs flex items-center gap-1" data-testid="membership-referral-copy"><Copy className="w-3 h-3" /> Copy</button>
              <button type="button" onClick={share} className="dg-btn-primary rounded-full px-3 py-2 text-xs flex items-center gap-1" data-testid="membership-referral-share"><Share2 className="w-3 h-3" /> Share</button>
            </div>
          </div>
          <div className="text-xs text-slate-500 mt-2" data-testid="membership-referral-count">
            {m.referrals ? `${m.referrals} friend${m.referrals === 1 ? "" : "s"} joined · ${m.free_months_earned} free month${m.free_months_earned === 1 ? "" : "s"} earned` : "No referrals yet — your code is " + m.referral_code}
            {m.next_milestone && <span data-testid="membership-referral-milestone"> · {m.next_milestone - m.referrals} more to the {m.next_milestone}-friend milestone (bonus month)</span>}
          </div>
        </div>
      </div>
    </div>
  );
}
